"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LinkUnlinkOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LinkUnlinkOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3A.5.5 0 0 1 5 4ZM9.307 1.121a3.828 3.828 0 0 1 5.413 0l.159.159a3.829 3.829 0 0 1 0 5.414l-2.48 2.48a.5.5 0 1 1-.707-.707l2.48-2.48a2.829 2.829 0 0 0 0-4l-.159-.159a2.828 2.828 0 0 0-3.999 0l-2.48 2.48a.5.5 0 1 1-.707-.706l2.48-2.48ZM4.308 6.826a.5.5 0 0 1 0 .707l-2.48 2.48a2.829 2.829 0 0 0 0 4l.159.159a2.828 2.828 0 0 0 3.999 0l2.48-2.48a.5.5 0 1 1 .707.706l-2.48 2.48a3.828 3.828 0 0 1-5.413 0l-.159-.158a3.829 3.829 0 0 1 0-5.414l2.48-2.48a.5.5 0 0 1 .707 0ZM0 5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 0 5ZM12.5 10.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM10.5 15.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LinkUnlinkOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LinkUnlinkOutline;
exports["default"] = _default;